import React, { FC, useState } from 'react';
import { Form, Formik } from 'formik';
import businessModelOptions from '../businessModelOption';
import COSelect from 'shared/components/COSelect';
import { Pagination } from 'antd';
import styles from './businessModalDropdown.module.scss';
import { PaginationConfig } from 'models/PaginationConfig/paginationConfig.model';
import { EmissionParams } from 'services/DashboardService/dashboard.service';
import { width88Class } from 'constants/constants';

interface BusinessModalDropdownProps {
  onDropdownOptionChange: (params: EmissionParams) => void;
  pagination: PaginationConfig;
  paramsState?: EmissionParams;
}

const BusinessModalDropdown: FC<BusinessModalDropdownProps> = props => {
  const { onDropdownOptionChange, pagination, paramsState } = props;

  const [category, setCategory] = useState<string>();

  const onCategoryChange = (value: string) => {
    setCategory(value);
    onDropdownOptionChange({
      ...paramsState,
      business_model: value,
      page: pagination.currentPage,
    });
  };

  return (
    <div className={styles.businessModalDropdown}>
      <Formik
        initialValues={{
          category: businessModelOptions[0].value,
        }}
        onSubmit={() => {}}>
        <Form className={width88Class}>
          <COSelect
            name="category"
            options={businessModelOptions}
            placeholderstring="Category"
            onChange={onCategoryChange}
            allowClear={false}
          />
        </Form>
      </Formik>
      <Pagination
        className="ml-5"
        simple
        hideOnSinglePage
        current={pagination.currentPage}
        total={pagination.totalItems}
        onChange={pageNo =>
          onDropdownOptionChange({
            ...paramsState,
            business_model: category ?? businessModelOptions[0].value,
            page: pageNo,
          })
        }
      />
    </div>
  );
};

export default BusinessModalDropdown;
